import React, { useEffect, useState } from "react";
import { Grid, Typography, Button, Avatar, Box } from "@mui/material";
// SpeedDial removed - using only notification FAB to avoid overlap
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import {
  faCog,
  faUser,
  faBullhorn,
  faIdBadge,
  faTimes,
  faBoxes,
  faCalendarAlt,
  faBirthdayCake,
  faFileAlt,
  faClock,
  faFingerprint,
  faSignOutAlt,
  faCheckCircle,
  faTimesCircle,
  faAdjust,
  faUmbrellaBeach,
  faMapMarkerAlt,
  faPhone,
  faBriefcase,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";

import { useNavigate } from "react-router-dom";
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./Dashboard.css";
import NotificationIcon from "../Notification/NotificationIcon";
import NotificationSlider from "../Notification/NotificationSlider";
import PageContainer from "../common/PageContainer";
// import StatsCard from "../common/StatsCard";
import StatusChip from "../common/StatusChip";

const BASE_URL = process.env.REACT_APP_BASE_URL;

ChartJS.register(
  Title,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
);

const centerTextPlugin = {
  id: "centerTextPlugin",
  afterDatasetsDraw() {
    // Disabled - using HTML overlay for center text instead
  },
};

const EmployeeDashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [profile, setProfile] = useState({
    name: "",
    email: "",
    contactNumber: "",
    employeeid: "",
    role: "",
    manager: "",
    offeredSalary: 0,
    TDSAmount: 0,
    dateOfJoining: "",
    jobLocation: "",
    workMode: "",
    dateOfBirth: "",
    documents: {
      panCard: "",
      aadharCard: "",
      latestDegree: "",
      drivingLicense: "",
      previousCompanyLetter: "",
    },
    profilePicture: null,
    leaveBalance: {
      annualLeave: 0,
      sickLeave: 0,
      casualleave: 0,
      Other: 0,
    },
    remainingLeave: {
      annualLeave: 0,
      sickLeave: 0,
      casualleave: 0,
      Other: 0,
    },
  });

  const [idCardModalOpen, setIdCardModalOpen] = useState(false);
  const [idCardImage, setIdCardImage] = useState(null);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [attendanceData, setAttendanceData] = useState(null);
  const [attendance, setAttendance] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [attendanceCounts, setAttendanceCounts] = useState({
    present: 0,
    absent: 0,
    halfDay: 0,
  });
  const [upcomingHoliday, setUpcomingHoliday] = useState(null);
  const [upcomingBirthday, setUpcomingBirthday] = useState(null);
  const [todaysHoliday, setTodaysHoliday] = useState(null);
  const [todaysBirthdays, setTodaysBirthdays] = useState([]);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [isNotificationSliderVisible, setNotificationSliderVisible] =
    useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (idCardModalOpen) {
      // Block screenshot keyboard shortcuts
      const handleKeyDown = (e) => {
        if (
          e.key === "PrintScreen" ||
          (e.ctrlKey && e.key === "p") || // Print
          (e.metaKey && e.shiftKey && e.key === "3") || // macOS screenshot
          (e.metaKey && e.shiftKey && e.key === "4") || // macOS screenshot
          (e.altKey && e.key === "PrintScreen") // Alt+PrintScreen
        ) {
          e.preventDefault();
          alert("Screenshots are disabled for security reasons.");
        }
      };

      // Disable text selection
      const handleSelectStart = (e) => {
        e.preventDefault();
      };

      window.addEventListener("keydown", handleKeyDown);
      document.addEventListener("selectstart", handleSelectStart);

      return () => {
        window.removeEventListener("keydown", handleKeyDown);
        document.removeEventListener("selectstart", handleSelectStart);
      };
    }
  }, [idCardModalOpen]);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const fetchNotificationCount = async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) return;

      const response = await fetch(`${BASE_URL}/api/notification/fetch`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      if (data.success) {
        setNotificationCount(data.notifications?.length || 0);
      }
    } catch (error) {
      console.error("Error fetching notification count:", error);
    }
  };

  const handleNotificationIconClick = () => {
    fetchNotificationCount();
    setNotificationSliderVisible((prev) => !prev);
  };

  useEffect(() => {
    fetchNotificationCount();
    const intervalId = setInterval(fetchNotificationCount, 30000);
    return () => clearInterval(intervalId);
  }, []);
  //
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const response = await fetch(
          `${BASE_URL}/api/employees/logineduser/myprofile`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to fetch profile");
        }

        const data = await response.json();
        setProfile({
          name: data.name || "",
          email: data.email || "",
          contactNumber: data.contactNumber || "",
          employeeid: data.employeeid || "",
          role: data.role || "",
          manager: data.manager || "",
          offeredSalary: data.offeredSalary || 0,
          TDSAmount: data.TDSAmount || 0,
          dateOfJoining: data.dateOfJoining || "",
          jobLocation: data.jobLocation || "",
          workMode: data.workMode || "",
          dateOfBirth: data.dateOfBirth || "",
          documents: {
            panCard: data.documents?.panCard || "",
            aadharCard: data.documents?.aadharCard || "",
            latestDegree: data.documents?.latestDegree || "",
            drivingLicense: data.documents?.drivingLicense || "",
            previousCompanyLetter: data.documents?.previousCompanyLetter || "",
          },
          profilePicture: data.profilePicture || null,
          idcard_pic: data.idcard_pic || null,
          leaveBalance: {
            annualLeave: data.leaveBalance?.annualLeave || 0,
            sickLeave: data.leaveBalance?.sickLeave || 0,
            casualleave: data.leaveBalance?.casualleave || 0,
            Other: data.leaveBalance?.Other || 0,
          },
          remainingLeave: {
            annualLeave: data.remainingLeave?.annualLeave || 0,
            sickLeave: data.remainingLeave?.sickLeave || 0,
            casualleave: data.remainingLeave?.casualleave || 0,
            Other: data.remainingLeave?.Other || 0,
          },
        });
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profile:", error.message);
        setError(error.message || "Something went wrong");
        setLoading(false);
      }
    };

    const fetchAttendanceData = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const response = await fetch(
          `${BASE_URL}/api/attendance/attendancerecords`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || "Failed to fetch attendance records"
          );
        }

        const records = await response.json();
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();
        const today = new Date();
        const currentDate = today.getDate();
        const daysInMonth = new Date(
          currentYear,
          currentMonth + 1,
          0
        ).getDate();

        const monthlyRecords = records.filter((record) => {
          const recordDate = new Date(record.checkInTime);
          return (
            recordDate.getMonth() === currentMonth &&
            recordDate.getFullYear() === currentYear
          );
        });

        let presentCount = 0;
        let halfDayCount = 0;
        let absentCount = 0;

        for (let day = 1; day <= daysInMonth; day++) {
          const date = new Date(currentYear, currentMonth, day);

          // Skip Sundays and future dates
          if (date.getDay() === 0 || date > today) continue;

          const recordForDate = monthlyRecords.find(
            (record) => new Date(record.checkInTime).getDate() === day
          );

          if (recordForDate) {
            // For today's record
            if (day === currentDate) {
              // If checked in but not checked out yet, count as present
              if (!recordForDate.checkOutTime) {
                presentCount++;
              }
              // If checked out, calculate based on working hours
              else {
                const workingHours = recordForDate.workingHours;
                const totalMinutes =
                  workingHours.hours * 60 + workingHours.minutes;

                if (totalMinutes >= 480) {
                  presentCount++;
                } else if (totalMinutes >= 240) {
                  halfDayCount++;
                } else {
                  // If worked less than 4 hours, count as absent
                  absentCount++;
                }
              }
            }
            // For past days
            else {
              const workingHours = recordForDate.workingHours;
              const totalMinutes =
                workingHours.hours * 60 + workingHours.minutes;

              if (totalMinutes >= 480) {
                presentCount++;
              } else if (totalMinutes >= 240) {
                halfDayCount++;
              } else {
                absentCount++;
              }
            }
          } else if (day < currentDate) {
            absentCount++;
          }
        }

        setAttendanceCounts({
          present: presentCount,
          absent: absentCount,
          halfDay: halfDayCount,
        });

        setAttendanceData({
          labels: ["Present", "Absent", "Half Day"],
          datasets: [
            {
              data: [presentCount, absentCount, halfDayCount],
              backgroundColor: ["#059669", "#DC2626", "#FFC107"],
              hoverOffset: 6,
              borderWidth: 0,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching attendance records:", error.message);
        setError("Error fetching attendance records");
      }
    };

    const fetchUpcomingHoliday = async () => {
      try {
        const token = sessionStorage.getItem("token");
        console.log("Token:", token);

        const response = await fetch(`${BASE_URL}/api/holidays/`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to fetch holiday data");
        }

        const holidays = await response.json();
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const holidaysWithDates = holidays.map((holiday) => {
          const date = new Date(holiday.date);
          date.setHours(0, 0, 0, 0);
          return { ...holiday, date };
        });

        const holidayToday = holidaysWithDates.find(
          (holiday) => holiday.date.getTime() === today.getTime()
        );
        setTodaysHoliday(holidayToday || null);

        const upcoming = holidaysWithDates
          .filter((holiday) => holiday.date >= today)
          .sort((a, b) => a.date - b.date)[0];

        setUpcomingHoliday(upcoming);
      } catch (error) {
        console.error("Error fetching holiday data:", error.message);
      }
    };

    const fetchUpcomingBirthday = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/api/employees/`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to fetch employee data");
        }

        const employees = await response.json();
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const employeesWithBirthdays = employees.filter(
          (employee) => employee.dateOfBirth && !employee.archive
        );

        if (employeesWithBirthdays.length === 0) {
          setUpcomingBirthday(null);
          setTodaysBirthdays([]);
          return;
        }

        const birthdayEmployees = employeesWithBirthdays.map((employee) => {
          const birthday = new Date(employee.dateOfBirth);
          birthday.setFullYear(today.getFullYear());
          birthday.setHours(0, 0, 0, 0);

          // Only move to next year if the birthday already passed (not on today's date)
          if (birthday < today) {
            birthday.setFullYear(today.getFullYear() + 1);
          }

          const birthMonth = new Date(employee.dateOfBirth).getMonth();
          const birthDate = new Date(employee.dateOfBirth).getDate();

          return {
            ...employee,
            birthday,
            isToday:
              birthMonth === today.getMonth() && birthDate === today.getDate(),
          };
        });

        const nearestBirthdayDate = birthdayEmployees.sort(
          (a, b) => a.birthday - b.birthday
        )[0]?.birthday;

        const upcomingBirthdays = birthdayEmployees.filter(
          (employee) =>
            employee.birthday.getTime() === nearestBirthdayDate.getTime()
        );

        setUpcomingBirthday(upcomingBirthdays);
        setTodaysBirthdays(birthdayEmployees.filter((employee) => employee.isToday));
      } catch (error) {
        console.error("Error fetching birthday data:", error.message);
      }
    };

    const fetchAttendance = async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          console.error("No token found, please log in.");
          return;
        }

        const response = await fetch(
          `${BASE_URL}/api/attendance/attendancerecords`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || "Failed to fetch attendance data"
          );
        }

        const data = await response.json();
        setAttendance(data);
      } catch (error) {
        console.error("Error fetching attendance data:", error.message);
      }
    };

    const fetchPendingRequests = async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          console.error("No token found, please log in.");
          return;
        }

        const response = await fetch(`${BASE_URL}/api/leave/pending`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || "Failed to fetch leave requests"
          );
        }

        const data = await response.json();
        setPendingRequests(data);
      } catch (error) {
        console.error("Error fetching pending leave requests:", error.message);
      }
    };
    const formatDateTime = (date) => {
      return date
        ? new Date(date).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })
        : "Not recorded";
    };

    fetchProfile();
    fetchAttendanceData();
    fetchUpcomingHoliday();
    fetchUpcomingBirthday();
    fetchAttendance();
    fetchPendingRequests();
  }, []);

  if (loading) {
    return (
      <PageContainer>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 300,
            gap: 2,
          }}
        >
          <Box className="loading-spinner" />
          <Typography sx={{ color: "#64748B", fontSize: "0.875rem" }}>
            Loading your dashboard...
          </Typography>
        </Box>
      </PageContainer>
    );
  }

  if (error) {
    return (
      <PageContainer>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 300,
            gap: 2,
            textAlign: "center",
          }}
        >
          <Typography sx={{ fontSize: "2rem" }}>!</Typography>
          <Typography sx={{ fontWeight: 600, color: "#0F172A", fontSize: "1.125rem" }}>
            Error Loading Dashboard
          </Typography>
          <Typography sx={{ color: "#64748B", fontSize: "0.875rem" }}>
            {error}
          </Typography>
          <Button
            variant="outlined"
            onClick={() => window.location.reload()}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              fontWeight: 500,
              mt: 1,
              color: "#1E40AF",
              borderColor: "#1E40AF",
            }}
          >
            Try Again
          </Button>
        </Box>
      </PageContainer>
    );
  }

  const handleNavigation = () => navigate("/NotificationForm");
  const handleLeaveRequest = () => navigate("/ApplyForLeave");
  const handleViewProfile = () => navigate("/UserProfile");
  const handleMyInventories = () => navigate("/MyInventories");
  const handleSeeMore = () => navigate("/ManagerleaveRequest");
  const handleMarkAttendance = () => navigate("/AttendancePortal");
  const handleViewAttendance = () => navigate("/GetMyAttendance");
  const handleViewIdCard = () => {
    if (profile?.idcard_pic) {
      setIdCardImage(profile.idcard_pic);
      setIdCardModalOpen(true);
    } else {
      setIdCardModalOpen(true); // Still open modal but show message
      setIdCardImage(null); // Explicitly set to null
    }
  };

  const formatTime = (timeString) => {
    const date = new Date(timeString);
    return date.toLocaleTimeString("en-US", { hour12: false });
  };
  const calculateWorkingTime = (checkIn, checkOut) => {
    const start = new Date(checkIn);
    const end = checkOut ? new Date(checkOut) : new Date();
    const diff = end - start;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    return { hours, minutes, seconds };
  };

  const calculateRemainingTime = (workingTime) => {
    const totalWorkingHours = 8;
    const { hours, minutes, seconds } = workingTime;

    const totalElapsedHours = hours + minutes / 60 + seconds / 3600;
    const remainingHours = totalWorkingHours - totalElapsedHours;

    if (remainingHours <= 0) return "Workday Complete";

    const remainingTotalSeconds = Math.floor(remainingHours * 3600);
    const remainingHoursOnly = Math.floor(remainingTotalSeconds / 3600);
    const remainingMinutes = Math.floor((remainingTotalSeconds % 3600) / 60);
    const remainingSeconds = remainingTotalSeconds % 60;

    return `${remainingHoursOnly}h ${remainingMinutes}m ${remainingSeconds}s`;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.toLocaleString("en-US", { day: "2-digit" });
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.toLocaleString("en-US", { year: "numeric" });
    const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
    return `${capitalizedMonth} ${day}, ${year}`;
  };

  const NextArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow next" onClick={onClick}>
        ▶
      </div>
    );
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow prev" onClick={onClick}>
        ◀
      </div>
    );
  };

  // Slider settings

  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? "Good Morning" : hour < 17 ? "Good Afternoon" : "Good Evening";
  const employeeName = " "; // or dynamic name

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    initialSlide: 0,
    lazyLoad: "ondemand",
    swipeToSlide: true,
    adaptiveHeight: true,
  };

  return (
    <PageContainer>
      <Box className="keka-dashboard">
        {/* ===== SECTION 1: Hero Welcome Banner ===== */}
        <div className="hero-banner">
          <div className="hero-left">
            <Avatar
              src={profile?.profilePicture || undefined}
              alt={profile.name}
              className="hero-avatar"
              sx={{
                width: { xs: 48, sm: 68 },
                height: { xs: 48, sm: 68 },
                background: profile?.profilePicture
                  ? undefined
                  : "linear-gradient(135deg, #667eea, #764ba2)",
                color: "#fff",
                fontWeight: 700,
              }}
            >
              {!profile?.profilePicture
                ? (profile?.name?.charAt(0)?.toUpperCase() || "U")
                : null}
            </Avatar>
            <div className="hero-text-block">
              <h2 className="hero-greeting">
                {greeting}, {profile.name || "there"}!
              </h2>
              <p className="hero-subtitle">
                what&apos;s happening in your organization today.
              </p>
              {(todaysHoliday || todaysBirthdays.length > 0) && (
                <div className="hero-highlights">
                  {todaysHoliday && (
                    <span className="hero-highlight hero-highlight-holiday">
                      <FontAwesomeIcon icon={faUmbrellaBeach} />
                      Holiday today: {todaysHoliday.name}
                    </span>
                  )}
                  {todaysBirthdays.length > 0 && (
                    <span className="hero-highlight hero-highlight-birthday">
                      <FontAwesomeIcon icon={faBirthdayCake} />
                      {todaysBirthdays.length === 1
                        ? `Birthday today: ${todaysBirthdays[0].name}`
                        : `Birthdays today: ${todaysBirthdays
                            .map((employee) => employee.name)
                            .join(", ")}`}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
          {!isMobile && (
            <div className="hero-right">
              <div className="hero-chip">
                <FontAwesomeIcon icon={faClock} style={{ fontSize: 13 }} />
                {currentTime.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
              <div className="hero-chip">
                <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: 13 }} />
                {currentTime.toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </div>
            </div>
          )}
        </div>

        {/* ===== SECTION 2: Gradient Stat Cards ===== */}
        <Grid container spacing={2.5} sx={{ mb: 3.5 }}>
          <Grid item xs={6} md={3}>
            <div className="stat-card-gradient stat-present">
              <FontAwesomeIcon icon={faCheckCircle} className="stat-icon" />
              <div>
                <div className="stat-number">{attendanceCounts.present}</div>
                <div className="stat-label">Present Days</div>
              </div>
            </div>
          </Grid>
          <Grid item xs={6} md={3}>
            <div className="stat-card-gradient stat-absent">
              <FontAwesomeIcon icon={faTimesCircle} className="stat-icon" />
              <div>
                <div className="stat-number">{attendanceCounts.absent}</div>
                <div className="stat-label">Absent Days</div>
              </div>
            </div>
          </Grid>
          <Grid item xs={6} md={3}>
            <div className="stat-card-gradient stat-halfday">
              <FontAwesomeIcon icon={faAdjust} className="stat-icon" />
              <div>
                <div className="stat-number">{attendanceCounts.halfDay}</div>
                <div className="stat-label">Half Days</div>
              </div>
            </div>
          </Grid>
          <Grid item xs={6} md={3}>
            <div className="stat-card-gradient stat-leave">
              <FontAwesomeIcon icon={faUmbrellaBeach} className="stat-icon" />
              <div>
                <div className="stat-number">
                  {(profile.remainingLeave?.annualLeave || 0) +
                    (profile.remainingLeave?.sickLeave || 0) +
                    (profile.remainingLeave?.casualleave || 0) +
                    (profile.remainingLeave?.Other || 0)}
                </div>
                <div className="stat-label">Leave Balance</div>
              </div>
            </div>
          </Grid>
        </Grid>

        {/* ===== SECTION 3: Quick Actions (App-Icon Style) ===== */}
        <Box sx={{ mb: 3.5 }}>
          <div className="quick-actions-row">
            {[
              { label: "Announce", icon: faBullhorn, onClick: handleNavigation, color: "qa-blue" },
              { label: "Profile", icon: faUser, onClick: handleViewProfile, color: "qa-green" },
              { label: "Apply Leave", icon: faFileAlt, onClick: handleLeaveRequest, color: "qa-orange" },
              { label: "Inventories", icon: faBoxes, onClick: handleMyInventories, color: "qa-purple" },
              { label: "ID Card", icon: faIdBadge, onClick: handleViewIdCard, color: "qa-teal" },
              { label: "Attendance", icon: faFingerprint, onClick: handleMarkAttendance, color: "qa-red" },
              { label: "My Records", icon: faClock, onClick: handleViewAttendance, color: "qa-indigo" },
            ].map((action, i) => (
              <div key={i} className="quick-action-item" onClick={action.onClick}>
                <div className={`quick-action-circle ${action.color}`}>
                  <FontAwesomeIcon icon={action.icon} />
                </div>
                <span className="quick-action-label">{action.label}</span>
              </div>
            ))}
          </div>
        </Box>

        {/* ===== SECTION 4: Two-Column Grid (Profile + Attendance Chart) ===== */}
        <Grid container spacing={3} sx={{ mb: 3.5 }}>
          {/* Left: Profile Card */}
          <Grid item xs={12} md={5}>
            <div className="keka-card">
              {/* Profile Header with Gradient Ring */}
              <div className="profile-card-header">
                <div className="profile-avatar-ring">
                  <Avatar
                    src={profile?.profilePicture || undefined}
                    alt={profile.name}
                    sx={{
                      width: "100%",
                      height: "100%",
                      border: "3px solid #fff",
                      background: profile?.profilePicture
                        ? undefined
                        : "linear-gradient(135deg, #667eea, #764ba2)",
                      color: "#fff",
                      fontWeight: 700,
                    }}
                  >
                    {!profile?.profilePicture
                      ? (profile?.name?.charAt(0)?.toUpperCase() || "U")
                      : null}
                  </Avatar>
                </div>
                <div>
                  <div className="profile-name">{profile.name || "Employee"}</div>
                  <span className="profile-role-badge">{profile.role || "Team Member"}</span>
                  <div className="profile-id">{profile.employeeid || "N/A"}</div>
                </div>
              </div>

              {/* Profile Details Grid */}
              <div className="profile-info-grid">
                {[
                  { icon: faEnvelope, label: "Email", value: profile.email },
                  { icon: faPhone, label: "Phone", value: profile.contactNumber ? `+91 ${profile.contactNumber}` : "N/A" },
                  { icon: faMapMarkerAlt, label: "Location", value: profile.jobLocation || "N/A" },
                  { icon: faBriefcase, label: "Work Mode", value: profile.workMode || "N/A" },
                  {
                    icon: faCalendarAlt,
                    label: "Joined",
                    value: profile.dateOfJoining
                      ? new Date(profile.dateOfJoining).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
                      : "N/A",
                  },
                  { icon: faUser, label: "Manager", value: profile.manager || "N/A" },
                ].map((item, idx) => (
                  <div key={idx} className="profile-info-item">
                    <span className="profile-info-label">
                      <FontAwesomeIcon icon={item.icon} />
                      {item.label}
                    </span>
                    <span className="profile-info-value">{item.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </Grid>

          {/* Right: Attendance Donut Chart */}
          <Grid item xs={12} md={7}>
            <div className="keka-card" style={{ display: "flex", flexDirection: "column" }}>
              <div className="keka-card-header">
                <span className="keka-card-title">
                  Attendance Overview &mdash;{" "}
                  {new Date().toLocaleString("default", { month: "long" })}{" "}
                  {new Date().getFullYear()}
                </span>
                <button className="view-details-btn" onClick={handleViewAttendance}>
                  View Details
                </button>
              </div>

              {attendanceData ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: { xs: 2, sm: 4 },
                    flex: 1,
                    flexDirection: { xs: "column", md: "row" },
                  }}
                >
                  {/* Donut */}
                  <div className="donut-container">
                    <Doughnut
                      data={{
                        labels: ["Present", "Absent", "Half Day"],
                        datasets: [
                          {
                            data: [
                              attendanceCounts.present,
                              attendanceCounts.absent,
                              attendanceCounts.halfDay,
                            ],
                            backgroundColor: ["#43e97b", "#f5576c", "#fccb90"],
                            borderColor: "#ffffff",
                            borderWidth: 3,
                            borderRadius: 6,
                            cutout: "75%",
                          },
                        ],
                      }}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: { display: false },
                          tooltip: { enabled: true },
                        },
                      }}
                    />
                    <div className="donut-center-text">
                      <div className="donut-center-percent">
                        {attendanceCounts.present +
                          attendanceCounts.absent +
                          attendanceCounts.halfDay >
                        0
                          ? Math.round(
                              (attendanceCounts.present /
                                (attendanceCounts.present +
                                  attendanceCounts.absent +
                                  attendanceCounts.halfDay)) *
                                100
                            )
                          : 0}
                        %
                      </div>
                      <div className="donut-center-label">Present</div>
                    </div>
                  </div>

                  {/* Legend + Today's Status */}
                  <Box sx={{ flex: 1, width: "100%" }}>
                    {[
                      { label: "Present", count: attendanceCounts.present, color: "#43e97b" },
                      { label: "Absent", count: attendanceCounts.absent, color: "#f5576c" },
                      { label: "Half Day", count: attendanceCounts.halfDay, color: "#fccb90" },
                    ].map((item) => (
                      <div key={item.label} className="legend-item">
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <div className="legend-dot" style={{ backgroundColor: item.color }} />
                          <span className="legend-label">{item.label}</span>
                        </Box>
                        <span className="legend-count">{item.count} days</span>
                      </div>
                    ))}

                    {/* Today's Punch Status */}
                    {(() => {
                      const today = new Date();
                      const todayRecord = attendance.find((record) => {
                        const checkInDate = new Date(record.checkInTime);
                        return (
                          checkInDate.getDate() === today.getDate() &&
                          checkInDate.getMonth() === today.getMonth() &&
                          checkInDate.getFullYear() === today.getFullYear()
                        );
                      });

                      if (todayRecord) {
                        const working = calculateWorkingTime(
                          todayRecord.checkInTime,
                          todayRecord.checkOutTime
                        );
                        return (
                          <div className="today-status-box">
                            <div className="today-status-label">Today's Status</div>
                            <div className="today-status-grid">
                              <div>
                                <div className="today-status-item-label">Punch In</div>
                                <div
                                  className="today-status-item-value"
                                  style={{ color: "#059669" }}
                                >
                                  {new Date(
                                    todayRecord.checkInTime
                                  ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </div>
                              </div>
                              <div>
                                <div className="today-status-item-label">Punch Out</div>
                                <div
                                  className="today-status-item-value"
                                  style={{
                                    color: todayRecord.checkOutTime
                                      ? "#DC2626"
                                      : "#94a3b8",
                                  }}
                                >
                                  {todayRecord.checkOutTime
                                    ? new Date(
                                        todayRecord.checkOutTime
                                      ).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                      })
                                    : "--:--"}
                                </div>
                              </div>
                              <div>
                                <div className="today-status-item-label">Hours</div>
                                <div
                                  className="today-status-item-value"
                                  style={{ color: "#1e293b" }}
                                >
                                  {working.hours}h {working.minutes}m
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                      return (
                        <div className="no-attendance-box">
                          <div className="no-attendance-text">
                            You haven't marked attendance for today.
                          </div>
                          <button
                            className="mark-attendance-btn"
                            onClick={handleMarkAttendance}
                          >
                            Mark Attendance
                          </button>
                        </div>
                      );
                    })()}
                  </Box>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flex: 1,
                    py: 6,
                  }}
                >
                  <Typography sx={{ fontSize: "0.875rem", color: "#94A3B8" }}>
                    Loading attendance data...
                  </Typography>
                </Box>
              )}
            </div>
          </Grid>
        </Grid>

        {/* ===== SECTION 5: Three-Column Grid (Holidays, Birthdays, Pending Leaves) ===== */}
        <Grid container spacing={3}>
          {/* Upcoming Holidays */}
          <Grid item xs={12} md={4}>
            <div className="accent-card accent-card-blue">
              <div className="keka-card-header">
                <span className="keka-card-title">Upcoming Holidays</span>
                <button
                  className="view-all-btn"
                  onClick={() => navigate("/HolidaysListForEmployees")}
                >
                  View All
                </button>
              </div>

              {upcomingHoliday ? (
                <div className="holiday-item">
                  <div className="holiday-icon-circle holiday-icon-blue">
                    <FontAwesomeIcon icon={faCalendarAlt} />
                  </div>
                  <div>
                    <div className="holiday-name">{upcomingHoliday.name}</div>
                    <div className="holiday-date">
                      {new Date(upcomingHoliday.date).toLocaleDateString(
                        "en-US",
                        {
                          weekday: "short",
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        }
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <p className="empty-state">No upcoming holidays</p>
              )}
            </div>
          </Grid>

          {/* Upcoming Birthdays */}
          <Grid item xs={12} md={4}>
            <div className="accent-card accent-card-pink">
              <div className="keka-card-header">
                <span className="keka-card-title">Upcoming Birthdays</span>
              </div>

              {upcomingBirthday && upcomingBirthday.length > 0 ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  {upcomingBirthday.slice(0, 4).map((employee) => (
                    <div key={employee.employeeid} className="birthday-item">
                      <div className="birthday-icon-circle">
                        <FontAwesomeIcon icon={faBirthdayCake} />
                      </div>
                      <div>
                        <div className="birthday-name">{employee.name}</div>
                        <div className="birthday-date">
                          {new Date(employee.birthday).toLocaleDateString(
                            "en-US",
                            {
                              month: "short",
                              day: "numeric",
                            }
                          )}
                          {employee.isToday && (
                            <span className="birthday-today-badge">
                              Today!
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="empty-state">No upcoming birthdays</p>
              )}
            </div>
          </Grid>

          {/* Pending Leave Requests */}
          <Grid item xs={12} md={4}>
            <div className="accent-card accent-card-orange">
              <div className="keka-card-header">
                <span className="keka-card-title">Pending Leave Requests</span>
                <button className="view-all-btn" onClick={handleSeeMore}>
                  See All
                </button>
              </div>

              {pendingRequests.length > 0 ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  {pendingRequests.slice(0, 4).map((request) => (
                    <div key={request._id} className="leave-request-item">
                      <div className="leave-request-header">
                        <span className="leave-request-name">
                          {request.employee.name}
                        </span>
                        <StatusChip
                          status={request.leaveType?.toLowerCase()}
                          label={request.leaveType}
                        />
                      </div>
                      <div className="leave-request-dates">
                        {new Date(request.startDate).toLocaleDateString(
                          "en-US",
                          { month: "short", day: "numeric" }
                        )}
                        {" - "}
                        {new Date(request.endDate).toLocaleDateString(
                          "en-US",
                          {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                          }
                        )}
                      </div>
                      {request.reason && (
                        <div className="leave-request-reason">
                          {request.reason}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="empty-state">No pending leave requests</p>
              )}
            </div>
          </Grid>
        </Grid>

        {/* Notification Icon & Slider */}
        <NotificationIcon
          onClick={handleNotificationIconClick}
          unreadCount={notificationCount}
        />
        {isNotificationSliderVisible && (
          <NotificationSlider
            isVisible={isNotificationSliderVisible}
            onClose={() => setNotificationSliderVisible(false)}
            onNotificationsChange={setNotificationCount}
          />
        )}

        {/* ID Card Modal */}
        {idCardModalOpen && (
          <div
            className="idcard-modal-overlay"
            onContextMenu={(e) => e.preventDefault()}
          >
            <div
              className="idcard-modal-content"
              style={{
                backgroundColor: idCardImage ? "transparent" : "#ffffff",
                borderRadius: idCardImage ? 0 : "16px",
              }}
              onContextMenu={(e) => e.preventDefault()}
            >
              <IconButton
                aria-label="close"
                onClick={() => setIdCardModalOpen(false)}
                sx={{
                  position: "absolute",
                  right: 10,
                  top: 10,
                  zIndex: 1,
                  color: "#fff",
                  background: "rgba(255,255,255,0.2)",
                  backdropFilter: "blur(8px)",
                  width: 36,
                  height: 36,
                  "&:hover": { backgroundColor: "rgba(220,38,38,0.9)" },
                }}
              >
                <FontAwesomeIcon icon={faTimes} style={{ fontSize: 14 }} />
              </IconButton>

              {idCardImage ? (
                <div style={{ position: "relative" }}>
                  <img
                    src={idCardImage}
                    alt="ID Card"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "calc(100vh - 100px)",
                      display: "block",
                      margin: "0 auto",
                      userSelect: "none",
                      pointerEvents: "none",
                      WebkitUserSelect: "none",
                      MozUserSelect: "none",
                      msUserSelect: "none",
                      WebkitTouchCallout: "none",
                      borderRadius: "16px",
                      boxShadow: "0 8px 40px rgba(0,0,0,0.4)",
                    }}
                    draggable="false"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background:
                        "repeating-linear-gradient(45deg, rgba(255,255,255,0.05), rgba(255,255,255,0.05) 1px, transparent 1px, transparent 10px)",
                      pointerEvents: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px",
                      color: "rgba(255,255,255,0.2)",
                      fontWeight: "bold",
                      letterSpacing: "2px",
                    }}
                  >
                    CONFIDENTIAL - {profile.name}
                  </div>
                </div>
              ) : (
                <Box sx={{ p: 4, maxWidth: 480 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      mb: 3,
                    }}
                  >
                    <Box
                      sx={{
                        width: 44,
                        height: 44,
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faIdBadge}
                        style={{ color: "#fff", fontSize: 20 }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "1.125rem",
                        color: "#0F172A",
                      }}
                    >
                      ID Card Not Available
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      p: 2.5,
                      bgcolor: "#f0f4f8",
                      borderRadius: "12px",
                      border: "1px solid #e2e8f0",
                      mb: 3,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "0.875rem",
                        color: "#64748B",
                        lineHeight: 1.6,
                      }}
                    >
                      Your ID card image has not been uploaded yet. Please
                      upload it from the Profile Settings section.
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1.5,
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => setIdCardModalOpen(false)}
                      sx={{
                        textTransform: "none",
                        borderRadius: "10px",
                        fontWeight: 500,
                        fontSize: "0.8125rem",
                        color: "#475569",
                        borderColor: "#e2e8f0",
                        "&:hover": {
                          borderColor: "#667eea",
                          color: "#667eea",
                        },
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        setIdCardModalOpen(false);
                        navigate("/ResetPassword");
                      }}
                      startIcon={
                        <FontAwesomeIcon
                          icon={faCog}
                          style={{ fontSize: 12 }}
                        />
                      }
                      sx={{
                        textTransform: "none",
                        borderRadius: "10px",
                        fontWeight: 600,
                        fontSize: "0.8125rem",
                        background:
                          "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        boxShadow: "0 4px 14px rgba(102,126,234,0.4)",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #5a6fd6 0%, #6a4292 100%)",
                          boxShadow: "0 6px 20px rgba(102,126,234,0.5)",
                        },
                      }}
                    >
                      Go to Profile Settings
                    </Button>
                  </Box>
                </Box>
              )}
            </div>
          </div>
        )}
      </Box>
    </PageContainer>
  );
};

export default EmployeeDashboard;
